
const ENIntegrations = {
	"Adicionar Integração": "Add Integration",
	"Alterar integração": "Change Integration",
	"Baixar Serviço": "Download Service",
	"Campos Integrados": "Integrated Fields",
	"Chave": "Key",
	"Deseja realmente excluir a integração": "Do you really want to delete the integration",
	"É necessario inserir ao menos uma origem de dados": "It is necessary to insert at least one data source",
	"Erro ao adicionar integração": "Error adding integration",
	"Erro ao alterar tipo de integração": "Error changing integration type",
	"Erro ao buscar serviço": "Error fetching service",
	"Erro ao excluir integração": "Error deleting integration",
	"Estação": "Station",
	"Exclusão de Integração": "Delete Integration",
	"Executável": "Executable",
	"Integração adicionada com sucesso": "Integration successfully added",
	"Integração alterada com sucesso": "Integration successfully changed",
	"Integração excluída com sucesso": "Integration successfully deleted",
	"Integração": "Integration",
	"Integrações - Chave de Acesso": "Integrations - Access Key",
	"Ip Externo": "External IP",
	"Ip Interno": "Internal IP",
	"Log de Integração": "Integration Log",
	"Logs de Integração": "Integration Logs",
	"Nova Chave": "New Key",
	"Serviços Instalados": "Installed Services",
	"Última verificação": "Last check",
	"Última Integração": "Last Integration",
	"Versão": "Version",
	"Visualizar Logs de Integração": "View Integration Logs"
};

export default ENIntegrations;
